import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Link' })((theme) => ({
    link: {
        color: theme.palette.default.main,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }
}));
